import { drawTextInBox, X_ALIGN_CENTER, X_ALIGN_LEFT, Y_ALIGN_CENTER } from "../pdfUtil/drawTextInBox";
import { rgb } from "pdf-lib";

// 発注書　表部分作成
export const createTable = (page, supplyDetails, pageProperties) => {

  const {width, height, margin, headerHeight, rowNumber, columns, fonts} = pageProperties;
  const colProperties = getColProperties(columns, margin, width - margin);
  const rowHeight = (height -  2 * margin - headerHeight) / (rowNumber + 1);

  createTableBone(
    page,
    {x: margin, y: height - margin - headerHeight},
    {x: width - margin, y: margin},
    rowNumber,
    rowHeight,
    fonts,
    colProperties
  );

  createTableDataRows(
    page,
    {x: margin, y: height - margin - headerHeight},
    supplyDetails,
    rowHeight,
    fonts,
    colProperties
  );
}

// 価格表の骨格作成
const createTableBone = (page, startCoords, endCoords, rowNumber, rowHeight, fonts, colProperties) => {

  const {x: startX, y: startY} = startCoords;
  const {x: endX, y: endY} = endCoords;

  // 横罫線
  Array.from(new Array(rowNumber + 1)).forEach((_, index) => {
    page.drawLine({
      start: { x: startX, y: startY - rowHeight * (index + 1)},
      end: { x: endX, y: startY - rowHeight * (index + 1)},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  })

  page.drawLine({
    start: { x: startX, y: startY - rowHeight + 2},
    end: { x: endX, y: startY - rowHeight + 2},
    thickness : 1,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  page.drawLine({
    start: { x: startX, y: startY },
    end: { x: endX, y: startY },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  page.drawLine({
    start: { x: startX, y: endY },
    end: { x: endX, y: endY },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  });

  // 縦罫線と表ヘッダ
  colProperties.forEach((colProp) => {    

    page.drawLine({
      start: { x: colProp.endX, y: startY},
      end: { x: colProp.endX, y: endY},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    drawTextInBox(
      page,
      colProp.label,
      {x1: colProp.startX, x2: colProp.endX, y1: startY, y2: startY - rowHeight},
      {xAlign: X_ALIGN_CENTER, yAlign: Y_ALIGN_CENTER, font: fonts.mincho_font, size: 15}
    );
  });

  page.drawLine({
    start: { x: startX, y: startY },
    end: { x: startX, y: endY },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  page.drawLine({
    start: { x: endX, y: startY },
    end: { x: endX, y: endY },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  });
};

const createTableDataRows = (page, startCoords, supplyDetails, rowHeight, fonts, colProperties) => {
  const {x: startX, y: startY} = startCoords;

  supplyDetails.reduce((prevDetail, thisDetail, detailIndex) => {
    colProperties.reduce((prevPropAreSame, colProp) => {
      const propAreSame = prevPropAreSame && colProp.getValue(prevDetail) === colProp.getValue(thisDetail);

      drawTextInBox(
        page,
        prevDetail && colProp.enabledOmit && propAreSame && colProp.getValue(thisDetail)
          ? "〃"
          : colProp.getValue(thisDetail)
        ,
        {
          x1: colProp.startX, x2: colProp.endX,
          y1: startY - rowHeight * (detailIndex + 1), y2: startY - rowHeight * (detailIndex + 2)
        },
        {
          xAlign: X_ALIGN_CENTER,
          yAlign: Y_ALIGN_CENTER,
          size: 12,
          font: fonts.mincho_font,
          ...(colProp.textOption || []),
        }
      );

      return propAreSame;
    }, true);

    return thisDetail;
  }, null);
}

const getColProperties = (cols, startX, endX) => {

  const sumWidthWeight = cols.reduce((prevSum, thisCol) => prevSum + thisCol.widthWeight, 0);
  const rowWidth = endX - startX;

  const colsProperties = [];

  cols.reduce((prevX, thisCol) => {
    colsProperties.push({...thisCol, startX: prevX, endX: prevX + thisCol.widthWeight * rowWidth / sumWidthWeight});
    return prevX + thisCol.widthWeight * rowWidth / sumWidthWeight;
  }, startX);

  return colsProperties;
}


